// @ts-ignore
// material-ui
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Slider,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';
import FlagIcon from '@material-ui/icons/Flag';
import GetAppIcon from '@material-ui/icons/GetApp';
import InfoIcon from '@material-ui/icons/Info';
import PublishIcon from '@material-ui/icons/Publish';
import { cloneDeep } from 'lodash-es';
import { MTableToolbar } from 'material-table';
import React, { ReactElement } from 'react';
import update from 'react-addons-update';

// apis
import {
  EAllowStatus,
  IContextualSegmentsForecast,
  makeTargetingChangeDescription,
  makeTargetingChangeInfoHover,
  PublisherRequestFieldContentGenre,
  PublisherRequestFieldContentRating,
  ResourceActiveDisabled,
  ResourceActiveEnabled,
  reverseEAllowStatus,
  runContextualSegmentsForecast,
  scheduleContextualSegmentsForecast,
  SegmentTargetingAND,
  SegmentTargetingOR,
  uploadCollectionDataCSVfile,
} from '~/src/dash/api/console-api';
import {
  createContentCollection,
  createContentCollectionData,
  createContextualSegment,
  createContextualSegmentLabel,
  deleteContentCollection,
  deleteContentCollectionData,
  deleteContextualSegment,
  generateContentList,
  generateContextualSegmentLabelsList,
  generateIASContextualSegmentList,
  generateIrisPartnersMenu,
  generateThirdPartyContextualSegmentList,
  generateThirdPartyMenu,
  getContentCollections,
  getContextualSegmentLabelsByPublisherID,
  IContentCollection,
  IContentCollectionData,
  IContextualSegment,
  IContextualSegmentLabel,
  IrisPartner,
  IrisPartnerUnknown,
  IThirdPartyContextualSegment,
  NO_MAX_CONTENT_LENGTH,
  NO_MIN_CONTENT_LENGTH,
  ThirdParty,
  ThirdPartyComscore,
  ThirdPartyIAS,
  ThirdPartyIris,
  updateContentCollection,
  updateContentCollectionData,
  updateContextualSegment,
} from '~/src/dash/api/contextual-segments';
import { EBool } from '~/src/dash/api/types/bool';
import { ComscoreContextualSelector } from '~/src/dash/components/comscore/contextual/funcs';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import { AutocompleteDropdown } from '~/src/dash/components/dropdowns/autocomplete-dropdown';
import { IInputRow, InputRow } from '~/src/dash/components/input-row';
import {
  IContentCollectionDataMapPairRow,
  IContentCollectionMapPairRow,
  IListTableColumn,
  ListTable,
} from '~/src/dash/components/list-table';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ModelPrimaryContainerV2 } from '~/src/dash/components/model-grid-container-v2';
import { ModelPrimaryButton } from '~/src/dash/components/model-primary-button';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { SettingsAppBar } from '~/src/dash/components/settings-app-bar';
import { ITab, SettingsTabs } from '~/src/dash/components/settings-tabs';
import { Panel, Panels } from '~/src/dash/publicaUI';
// other
import { IStore } from '~/src/dash/reducers/store';
import {
  extractRouteParams,
  genDownloadCollectionDataCSVURL,
  navigate,
  RouteContextualSegmentExisting,
  RouteContextualSegmentSettingsList,
} from '~/src/dash/router/routes';
import { IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { IPermissionCheck, IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { checkUserInfoMasked, hasRole, hasRoleSuperUser, ROLE_SUPER } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { hasErrors, IErrors } from '~/src/dash/utils/validator';
import { LoadingView } from '~/src/dash/views/loading-view';
// views
import { SnackbarView } from '~/src/dash/views/snackbar-view';

// NOTE: For settings views, it is preferred to follow this model where there is a child view
// that is responsible for the majority of the react code and several various parent views
// connected to various routes, in this case, route-settings-clone-view, route-settings-existing-view,
// and route-settings-new-view, which pass on the current Route as props to this view.
// The parent view can pass on a blank resource, a clean clone or the resource from the api.

// The resource is then placed directly into state. You can note that within state, fields that
// belong to the resource (and thus are updated via API) should be capitalized, and the other items
// in state (like loading, snackbarError, pageNumber, etc) should be lower case.  The state can then be
// destructured into the resouce when creating or updating since we send back the whole object
// to the API, making it easier to update APIs when adding new fields.

// NOTE: Please add comments to IProps and IState to explain what certain variables do, especially if it
// may be unclear.  Try to keep them grouped if they may be related. Lastly, try to keep comments to IProps
// and IState rather than in the state declaration to keep it clean.

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  currentContextualSegment: IContextualSegment;
}

// NOTE: IState extends IInventoryRoute since we will place the route directly into state

interface IState extends IBaseState, IContextualSegment {
  // error msging to user
  snackbarMessage: string;
  snackbarError: boolean;
  updating: boolean; // indicates an api call to update is in progress
  loading: boolean; // indicates an api call to update is in progress
  startingTab: number;
  // lists for dropdowns
  contentRatingList: IMenuList;
  contentGenreList: IMenuList;
  contextualSegmentLabelsList: IMenuList;
  thirdPartyContextualSegmentsList: IMenuList[];
  allPublisherContextualSegments: IContextualSegmentLabel[];
  // forecasting
  forecast?: IContextualSegmentsForecast;
  runningForecast: boolean;
  schedulingForecast: boolean;
  contentCollectionList: IMenuList;
  manageCollectionList: IMenuList;
  // Open Dialogs for different Content Collections CRUD options
  openContentCollectionDialog: boolean;
  openCreateCollectionDialog: boolean;
  openCreateCollectionDataDialog: boolean;
  openEditCollectionDialog: boolean;
  openEditCollectionDataDialog: boolean;
  // Collections variables
  newCollectionName: string;
  editCollectionID: number;
  manageCollectionSelectedID: number;
  selectedContentCollection: IContentCollection;
  contentCollections: IContentCollection[];
  contentCollectionDialogID: number;
  contentCollectionMapData: IContentCollectionMapPairRow[];
  // Collection Data variables
  editCollectionDataID: number;
  contentCollectionData: IContentCollectionData[];
  newCollectionDataName: string;
  newCollectionDataID: string;
  contentCollectionDataDialogID: number;
  contentCollectionDataMapData: IContentCollectionDataMapPairRow[];
  startingManageCollectionTab: number;
}

const findSelectedIDs = (menuList: IMenuList): string[] => {
  const selectedIDs = [] as string[];
  for (const key in menuList) {
    if (menuList[key].selected) {
      selectedIDs.push(menuList[key].ID);
    }
  }

  return selectedIDs;
};

export const ContextualSegmentSettingsView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    // NOTE: Use styles when the CSS is used more than once
    styles: (_theme: any) => ({
      typographyFont: {
        fontSize: 16,
        fontWeight: 400,
        color: '$434343',
      },
      typographyFontBold: {
        fontSize: 16,
        fontWeight: 500,
        color: '$434343',
      },
      maxWidthGrid: {
        maxWidth: 1000,
        marginTop: 10,
        marginBottom: 10,
      },
      maxWidthMaxHeightGrid: {
        maxWidth: 1000,
        height: 85,
        marginTop: 10,
        marginBottom: 10,
      },
      addTypography: {
        fontSize: 16,
        fontWeight: 500,
        color: '#5865E8',
        marginLeft: 5,
        paddingBottom: 15,
        cursor: 'pointer',
      },
      checkbox: {
        transform: 'scale(0.8)',
        padding: 3,
      },
      table: {
        display: 'inline-block',
        marginTop: '10px',
        marginBottom: '10px',
      },
      danger: {
        color: 'red',
      },
      success: {
        color: 'green',
      },
      section: {
        display: 'block',
        marginBottom: _theme.spacing.unit * 3,
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      ...this.props.currentContextualSegment,
      snackbarMessage: '',
      snackbarError: false,
      updating: false,
      loading: true,
      startingTab: 0,
      contentRatingList: {} as IMenuList,
      contentGenreList: {} as IMenuList,
      contextualSegmentLabelsList: {} as IMenuList,
      allPublisherContextualSegments: [] as IContextualSegmentLabel[],
      thirdPartyContextualSegmentsList: [] as IMenuList[],
      forecast: {} as IContextualSegmentsForecast,
      runningForecast: false,
      schedulingForecast: false,
      selectedContentCollection: {} as IContentCollection,
      contentCollectionList: {} as IMenuList,
      manageCollectionList: {} as IMenuList,
      manageCollectionSelectedID: 0,
      openContentCollectionDialog: false,
      openCreateCollectionDialog: false,
      openCreateCollectionDataDialog: false,
      openEditCollectionDialog: false,
      openEditCollectionDataDialog: false,
      newCollectionName: '',
      editCollectionID: 0,
      editCollectionDataID: 0,
      contentCollections: [] as IContentCollection[],
      contentCollectionData: [] as IContentCollectionData[],
      newCollectionDataName: '',
      newCollectionDataID: '',
      contentCollectionDataDialogID: 0,
      contentCollectionDialogID: 0,
      contentCollectionMapData: [] as IContentCollectionMapPairRow[],
      contentCollectionDataMapData: [] as IContentCollectionDataMapPairRow[],
      startingManageCollectionTab: 0,
    };

    componentDidMount() {
      getContextualSegmentLabelsByPublisherID(this.props.session.publisher.ID)
        .then((resp) => {
          this.setState({
            thirdPartyContextualSegmentsList: this.state.ThirdPartyContextualSegments.map(
              (thirdParty) =>
                generateThirdPartyContextualSegmentList(
                  thirdParty.ThirdParty,
                  thirdParty.IrisPartner,
                  thirdParty.TargetingSegment.split(','),
                ),
            ),
            allPublisherContextualSegments: resp[0] || [],
            contextualSegmentLabelsList: generateContextualSegmentLabelsList(
              resp[0] || [],
              this.state.ContextualSegmentLabels,
            ),
            contentRatingList: generateContentList(
              this.props.session.publisher.PublisherEndpointRequestOptions,
              PublisherRequestFieldContentRating,
              this.state.TargetingContentRating.split(','),
            ),
            contentGenreList: generateContentList(
              this.props.session.publisher.PublisherEndpointRequestOptions,
              PublisherRequestFieldContentGenre,
              this.state.TargetingContentGenre.split(','),
            ),
            loading: false,
          });
          this.genContentCollections();
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Error loading segment labels',
            loading: false,
          });
        });
    }

    // -------- COMPONENT HELPER FUNCTIONS -------- //

    // NOTE: make functions for permissions (super, canEdit, masking) to reduce potential errors
    isSuper = (): boolean => {
      return hasRole(this.props.user.user, [ROLE_SUPER]);
    };

    isUserInfoMasked = (): boolean => {
      return checkUserInfoMasked(this.props.user.user);
    };

    hasWriteRights = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_audience_manager'], this.props.user.user);
    };

    generateContextualSegment = (): IContextualSegment => {
      return {
        ID: this.state.ID,
        CreatedAt: this.state.CreatedAt,
        DeletedAt: this.state.DeletedAt,
        UpdatedAt: this.state.UpdatedAt,
        PublisherID: parseInt(this.props.session.publisher.ID, 10),
        Name: this.state.Name,
        Active: this.state.Active,
        TargetingContentRating: this.state.TargetingContentRating,
        TargetingContentRatingIsAllowed: this.state.TargetingContentRatingIsAllowed,
        TargetingContentGenre: this.state.TargetingContentGenre,
        TargetingContentGenreIsAllowed: this.state.TargetingContentGenreIsAllowed,
        MaxContentLength: this.state.MaxContentLength,
        MinContentLength: this.state.MinContentLength,
        ThirdPartyTargetingType: this.state.ThirdPartyTargetingType,
        OnlyTargetCertifiedFullyOnScreen: this.state.OnlyTargetCertifiedFullyOnScreen,
        ContentCollectionID: this.state.ContentCollectionID,
        ContentCollection: this.state.selectedContentCollection,

        Deals: this.state.Deals,
        Headerbidders: this.state.Headerbidders,
        AdserverCampaigns: this.state.AdserverCampaigns,
        ContextualSegmentLabels: this.state.ContextualSegmentLabels,
        ThirdPartyContextualSegments: this.state.ThirdPartyContextualSegments,
      } as IContextualSegment;
    };

    validateContextualSegment = (): string[] => {
      const segment = this.generateContextualSegment();
      const errors = [] as string[];
      const hasThirdPartySegments = segment.ThirdPartyContextualSegments.length;
      if (segment.Name === 'New Contextual Segment') {
        errors.push('Enter a non-default name');
      }

      if (segment.Name.trim() === '') {
        errors.push('Enter a name');
      }

      if (
        !hasThirdPartySegments &&
        segment.TargetingContentGenre === '' &&
        segment.TargetingContentRating === '' &&
        segment.MaxContentLength === NO_MAX_CONTENT_LENGTH &&
        segment.MinContentLength === NO_MIN_CONTENT_LENGTH &&
        segment.ContentCollectionID === undefined &&
        segment.OnlyTargetCertifiedFullyOnScreen !== EBool.EBool_TRUE
      ) {
        errors.push(
          'Enter a non-default content rating, genre, collection or length or turn on OnlyTargetCertifiedFullyOnScreen',
        );
      }

      for (const thirdParty of segment.ThirdPartyContextualSegments) {
        if (thirdParty.TargetingSegment === '') {
          errors.push('Enter a non-default segment targeting for third parties');
        }
        if (
          thirdParty.ThirdParty === ThirdPartyIAS &&
          this.props.session.publisher.IASContextualSegmentsEnabled !== EBool.EBool_TRUE
        ) {
          errors.push('Please talk to an IAS representative to enable IAS contextual segments');
        }
        if (
          thirdParty.ThirdParty === ThirdPartyIris &&
          this.props.session.publisher.IrisContextualSegmentsEnabled !== EBool.EBool_TRUE
        ) {
          errors.push(
            'Please talk to an IRIS.TV representative to enable IRIS.TV contextual segments',
          );
        }
        if (
          thirdParty.ThirdParty === ThirdPartyIris &&
          thirdParty.IrisPartner === IrisPartnerUnknown
        ) {
          errors.push('Please select a partner for the IRIS.TV data source');
        }
        if (
          thirdParty.ThirdParty === ThirdPartyComscore &&
          this.props.session.publisher.ComscoreContextualSegmentsEnabled !== EBool.EBool_TRUE
        ) {
          errors.push(
            'Please talk to an Comscore representative to enable comscore contextual segments',
          );
        }
      }

      return errors;
    };

    generateThirdPartyContextualSegmentsForQuery = (): [
      IThirdPartyContextualSegment[],
      IThirdPartyContextualSegment[],
    ] => {
      const { ThirdPartyContextualSegments } = this.state;
      const iasContextualSegments = ThirdPartyContextualSegments.filter(
        (segment) => segment.ThirdParty === ThirdPartyIAS,
      );
      const iasContextualSegmentsQuery = iasContextualSegments.map((segment) => {
        const sortedTargetingSegment = segment.TargetingSegment.toLowerCase().split(',');
        sortedTargetingSegment.sort();
        return Object.assign({}, segment, {
          TargetingSegment: sortedTargetingSegment.join(','),
        });
      });

      const irisContextualSegments = ThirdPartyContextualSegments.filter(
        (segment) => segment.ThirdParty === ThirdPartyIris,
      );
      const irisContextualSegmentsQuery = irisContextualSegments.map((segment) => {
        const sortedTargetingSegment = segment.TargetingSegment.toLowerCase().split(',');
        sortedTargetingSegment.sort();
        return Object.assign({}, segment, {
          TargetingSegment: sortedTargetingSegment.join(','),
        });
      });

      return [iasContextualSegmentsQuery, irisContextualSegmentsQuery];
    };

    // Generates Data for Collection table
    genContentCollectionTableData = (contentCollections: IContentCollection[]) => {
      const contentCollectionMapData: IContentCollectionMapPairRow[] = contentCollections.map(
        (pair: IContentCollection) => {
          return {
            ID: pair.ID,
            Name: pair.Name,
            CollectionTitles: pair.ContentCollectionData.length,
          };
        },
      );
      this.setState({
        contentCollectionMapData,
      });
    };

    // Generates Data for Collection Data table
    genContentCollectionDataTableData = (
      collectionID: number,
      contentCollections: IContentCollection[],
    ) => {
      const collection = contentCollections.find((item) => item.ID === collectionID);
      if (collection) {
        const contentCollectionDataMapData: IContentCollectionDataMapPairRow[] =
          collection.ContentCollectionData.map((pair: IContentCollectionData) => {
            return {
              ID: pair.ID,
              Name: pair.Custom10TargetingAlias,
              Custom10TargetingAlias: pair.Custom10TargetingAlias,
              Custom10Targeting: pair.Custom10Targeting,
            };
          });
        this.setState({
          contentCollectionDataMapData,
        });
      }
    };

    // Gets all Collections and Collection Data in one go and generates the tables with that data
    genContentCollections = () => {
      getContentCollections({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      })
        .then((response: { contentCollection: IContentCollection[] }) => {
          // generate collection lists for dropdowns
          const contentCollectionList: IMenuList = {};
          const manageCollectionList: IMenuList = {};

          response.contentCollection.forEach((cg: IContentCollection) => {
            contentCollectionList[cg.ID] = {
              title: cg.Name,
              selected:
                this.state.ContentCollectionID !== 0
                  ? this.state.ContentCollectionID === cg.ID
                  : false,
              ID: cg.ID.toString(),
            };
            manageCollectionList[cg.ID] = {
              title: cg.Name,
              selected: cg.ID === this.state.manageCollectionSelectedID,
              ID: cg.ID.toString(),
            };
          });

          this.genContentCollectionTableData(response.contentCollection);
          this.genContentCollectionDataTableData(
            this.state.manageCollectionSelectedID,
            response.contentCollection,
          );
          this.setState({
            contentCollections: response.contentCollection,
            contentCollectionList,
            manageCollectionList,
          });
        })
        .catch(() => {
          this.setState({
            contentCollections: [],
            contentCollectionList: {} as IMenuList,
            manageCollectionList: {} as IMenuList,
          });
        });
    };

    runForecast = () => {
      const { session, user } = this.props;
      const {
        MaxContentLength,
        MinContentLength,
        TargetingContentGenre,
        TargetingContentGenreIsAllowed,
        TargetingContentRating,
        TargetingContentRatingIsAllowed,
        ThirdPartyTargetingType,
      } = this.state;

      this.setState(
        {
          runningForecast: true,
        },
        () => {
          const [iasContextualSegmentsQuery, irisContextualSegmentsQuery] =
            this.generateThirdPartyContextualSegmentsForQuery();

          runContextualSegmentsForecast(
            {
              publisher_id: parseInt(session.publisher.ID, 10),
              content_genres: TargetingContentGenre.split(',').filter(
                (contentGenre) => contentGenre !== '',
              ),
              content_genres_included: TargetingContentGenreIsAllowed,
              content_ratings: TargetingContentRating.split(',').filter(
                (contentRating) => contentRating !== '',
              ),
              content_ratings_included: TargetingContentRatingIsAllowed,
              ias_contextual_infos: iasContextualSegmentsQuery,
              iris_contextual_infos: irisContextualSegmentsQuery,
              min_content_length: MinContentLength,
              max_content_length: MaxContentLength,
              third_party_targeting_type: ThirdPartyTargetingType,
              timezone: user.publisher.Timezone || '',
            },
            session.publisher.ID,
          )
            .then(([forecast]) => {
              this.setState({
                forecast,
                runningForecast: false,
              });
            })
            .catch(() => {
              this.setState({
                runningForecast: false,
                snackbarError: true,
                snackbarMessage: 'Error running contextual segments forecast',
              });
            });
        },
      );
    };

    scheduleForecast = () => {
      const { session, user } = this.props;
      const {
        MaxContentLength,
        MinContentLength,
        schedulingForecast,
        TargetingContentGenre,
        TargetingContentGenreIsAllowed,
        TargetingContentRating,
        TargetingContentRatingIsAllowed,
        ThirdPartyTargetingType,
      } = this.state;
      this.setState(
        {
          schedulingForecast: true,
        },
        () => {
          const [iasContextualSegmentsQuery, irisContextualSegmentsQuery] =
            this.generateThirdPartyContextualSegmentsForQuery();

          scheduleContextualSegmentsForecast(
            {
              publisher_id: parseInt(session.publisher.ID, 10),
              content_genres: TargetingContentGenre.split(',').filter(
                (contentGenre) => contentGenre !== '',
              ),
              content_genres_included: TargetingContentGenreIsAllowed,
              content_ratings: TargetingContentRating.split(',').filter(
                (contentRating) => contentRating !== '',
              ),
              content_ratings_included: TargetingContentRatingIsAllowed,
              ias_contextual_infos: iasContextualSegmentsQuery,
              iris_contextual_infos: irisContextualSegmentsQuery,
              min_content_length: MinContentLength,
              max_content_length: MaxContentLength,
              third_party_targeting_type: ThirdPartyTargetingType,
              timezone: user.publisher.Timezone || '',
            },
            session.publisher.ID,
          )
            .then(() => {
              this.setState({
                snackbarError: false,
                snackbarMessage: 'Successfully scheduled contextual segments forecast',
                schedulingForecast: false,
              });
            })
            .catch(() => {
              this.setState({
                schedulingForecast: false,
                snackbarError: true,
                snackbarMessage: 'Error scheduling contextual segments forecast',
              });
            });

          // set schedulingForecast as false if we did not receive response in 5 seconds (which means system is querying data)
          setTimeout(() => {
            if (schedulingForecast) {
              this.setState({
                schedulingForecast: false,
              });
            }
          }, 5000);
        },
      );
    };

    // -------- HANDLER FUNCTIONS -------- //
    // NOTE: functions passed into a child component which update state in the parent
    // should be called handleFunc.  They are used to not directly modify the props/state
    // and make sure the parent component is properly re-rendered

    // Top bar name change
    handleNameChange = (name: string): void => {
      this.setState({
        Name: name,
      });
    };

    // Top bar close
    handleClose = (): void => {
      navigate(
        RouteContextualSegmentSettingsList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    // Top bar save when switching active
    handleChangeActive = () => {
      this.setState(
        {
          Active:
            this.state.Active === ResourceActiveEnabled
              ? ResourceActiveDisabled
              : ResourceActiveEnabled,
        },
        this.handleSave,
      );
    };

    // Top bar save
    handleSave = (): void => {
      if (this.state.updating) {
        return;
      }

      this.setState(
        {
          updating: true,
        },
        () => {
          const generatedContextualSegment = this.generateContextualSegment();
          const errors = this.validateContextualSegment();
          if (errors.length > 0) {
            this.setState({
              updating: false,
              snackbarError: true,
              snackbarMessage: errors.join(', '),
            });
            return;
          }

          if (generatedContextualSegment.ID === 0) {
            createContextualSegment(generatedContextualSegment, this.props.session.publisher.ID)
              .then((resp) => {
                const contextualSegment = resp[0];
                this.setState(
                  {
                    snackbarMessage: 'Successfully saved contextual segment.',
                    snackbarError: false,
                    updating: false,
                    openFallbackModal: false,
                  },
                  () => {
                    if (contextualSegment) {
                      setTimeout(() => {
                        navigate(RouteContextualSegmentExisting, extractRouteParams(this.props), {
                          p: this.props.session.publisher.ID,
                          contextual: contextualSegment.ID.toString(),
                        });
                      }, 500);
                    } else {
                      setTimeout(() => {
                        navigate(
                          RouteContextualSegmentSettingsList,
                          extractRouteParams(this.props),
                          {
                            p: this.props.session.publisher.ID,
                          },
                        );
                      }, 500);
                    }
                  },
                );
              })
              .catch((err) => {
                this.setState({
                  snackbarMessage: `Failed to save contextual segment: ${err}`,
                  snackbarError: true,
                  updating: false,
                  openFallbackModal: false,
                });
              });
          } else {
            updateContextualSegment(generatedContextualSegment, this.props.session.publisher.ID)
              .then(() => {
                this.setState({
                  snackbarMessage: 'Successfully saved contextual segment.',
                  snackbarError: false,
                  updating: false,
                  openFallbackModal: false,
                });
              })
              .catch((err) => {
                this.setState({
                  snackbarMessage: `Failed to save contextual segment: ${err}`,
                  snackbarError: true,
                  updating: false,
                  openFallbackModal: false,
                });
              });
          }
        },
      );
    };

    // Top bar delete
    handleDelete = (): void => {
      if (this.state.updating) {
        return;
      }

      this.setState(
        {
          updating: true,
        },
        () => {
          if (this.state.ID === 0) {
            this.handleClose();
          } else {
            deleteContextualSegment(this.state.ID.toString(), this.props.session.publisher.ID)
              .then(() => {
                this.handleClose();
              })
              .catch((err: any) => {
                console.error(err);
                this.setState({
                  updating: false,
                  snackbarMessage: 'Error while deleting contextual segment.',
                  snackbarError: true,
                });
              });
          }
        },
      );
    };

    handleChangeThirdParty = (value: ThirdParty, idx: number) => {
      const ThirdPartyContextualSegments = cloneDeep(this.state.ThirdPartyContextualSegments);
      ThirdPartyContextualSegments[idx].ThirdParty = value;
      ThirdPartyContextualSegments[idx].TargetingSegment = '';
      ThirdPartyContextualSegments[idx].TargetingSegmentIsAllowed =
        value !== ThirdPartyIAS ? EAllowStatus.ALLOW : EAllowStatus.DENY;

      const thirdPartyContextualSegmentsList = cloneDeep(
        this.state.thirdPartyContextualSegmentsList,
      );
      thirdPartyContextualSegmentsList[idx] = generateThirdPartyContextualSegmentList(
        value,
        ThirdPartyContextualSegments[idx].IrisPartner,
        [],
      );

      this.setState({
        ThirdPartyContextualSegments,
        thirdPartyContextualSegmentsList,
      });
    };

    handleChangeIrisPartner = (value: IrisPartner, idx: number) => {
      const ThirdPartyContextualSegments = cloneDeep(this.state.ThirdPartyContextualSegments);
      ThirdPartyContextualSegments[idx].IrisPartner = value;
      ThirdPartyContextualSegments[idx].TargetingSegment = '';

      const thirdPartyContextualSegmentsList = cloneDeep(
        this.state.thirdPartyContextualSegmentsList,
      );
      thirdPartyContextualSegmentsList[idx] = generateThirdPartyContextualSegmentList(
        ThirdPartyContextualSegments[idx].ThirdParty,
        value,
        [],
      );

      this.setState({
        ThirdPartyContextualSegments,
        thirdPartyContextualSegmentsList,
      });
    };

    handleChangeList = (newList: IMenuList, field: string, idx: number) => {
      const content = [] as string[];
      for (const item of Object.values(newList)) {
        if (item.selected) {
          content.push(item.ID);
        }
      }
      if (field === 'contentGenreList') {
        this.setState({
          TargetingContentGenre: content.join(','),
          contentGenreList: newList,
        });
      } else if (field === 'contentRatingList') {
        this.setState({
          TargetingContentRating: content.join(','),
          contentRatingList: newList,
        });
      } else if (field === 'contextualSegmentLabelsList') {
        const ContextualSegmentLabels = [] as IContextualSegmentLabel[];
        for (const item of Object.values(newList)) {
          if (item.selected) {
            ContextualSegmentLabels.push(item.object);
          }
        }
        this.setState({
          ContextualSegmentLabels,
          contextualSegmentLabelsList: newList,
        });
      } else if (field === 'thirdPartyContextualSegmentsList') {
        const ThirdPartyContextualSegments = cloneDeep(this.state.ThirdPartyContextualSegments);
        ThirdPartyContextualSegments[idx].TargetingSegment = content.join(',');
        const thirdPartyContextualSegmentsList = cloneDeep(
          this.state.thirdPartyContextualSegmentsList,
        );
        thirdPartyContextualSegmentsList[idx] = newList;
        this.setState({
          ThirdPartyContextualSegments,
          thirdPartyContextualSegmentsList,
        });
      }
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>, idx?: any) => {
      if (['ThirdPartyTargetingType'].includes(target.name)) {
        this.setState({
          [target.name]: parseInt(target.value.split(',').join(''), 10)
            ? parseInt(target.value.split(',').join(''), 10)
            : 0,
        });
      } else if (idx !== undefined) {
        const ThirdPartyContextualSegments = cloneDeep(this.state.ThirdPartyContextualSegments);
        // @ts-ignore
        ThirdPartyContextualSegments[idx][target.name] = target.value;
        this.setState({
          ThirdPartyContextualSegments,
        });
      } else {
        this.setState({
          [target.name]: target.value,
        });
      }
    };

    handleChangeMarked = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (['ThirdPartyTargetingType'].includes(target.name)) {
        this.setState({
          [target.name]: parseInt(target.value.split(',').join(''), 10)
            ? parseInt(target.value.split(',').join(''), 10)
            : 0,
        });
      } else {
        this.setState({
          [target.name]: target.value,
        });
      }
    };

    handleAddSegmentLabel = (newValue: string) => {
      if (this.state.updating) {
        return;
      }
      this.setState(
        {
          updating: true,
        },
        () => {
          createContextualSegmentLabel(
            {
              ID: 0,
              Name: newValue,
              PublisherID: parseInt(this.props.session.publisher.ID, 10),
              ContextualSegments: [this.generateContextualSegment()],
            },
            this.props.session.publisher.ID,
          )
            .then((resp) => {
              const ContextualSegmentLabels = cloneDeep(this.state.ContextualSegmentLabels);
              const allPublisherContextualSegments = cloneDeep(
                this.state.allPublisherContextualSegments,
              );
              if (resp[0]) {
                ContextualSegmentLabels.push(resp[0]);
                allPublisherContextualSegments.push(resp[0]);
              }
              this.setState({
                ContextualSegmentLabels,
                allPublisherContextualSegments,
                contextualSegmentLabelsList: generateContextualSegmentLabelsList(
                  allPublisherContextualSegments,
                  ContextualSegmentLabels,
                ),
                updating: false,
              });
            })
            .catch(() => {
              this.setState({
                snackbarError: true,
                snackbarMessage: 'Error creating segment label',
                updating: false,
              });
            });
        },
      );
    };

    handleChangeSliderSelection = (newValues: number | number[]) => {
      if (typeof newValues === 'object' && newValues.length === 2) {
        this.setState({
          MaxContentLength: newValues[1],
          MinContentLength: newValues[0],
        });
      }
    };

    handleDeleteThirdPartyContextualSegment = (idx: number) => {
      const ThirdPartyContextualSegments = cloneDeep(this.state.ThirdPartyContextualSegments);
      const thirdPartyContextualSegmentsList = cloneDeep(
        this.state.thirdPartyContextualSegmentsList,
      );
      ThirdPartyContextualSegments.splice(idx, 1);
      thirdPartyContextualSegmentsList.splice(idx, 1);

      this.setState({
        ThirdPartyContextualSegments,
        thirdPartyContextualSegmentsList,
      });
    };

    handleAddThirdPartyContextualSegment = () => {
      const newThirdPartyContextualSegment = {
        ID: 0,
        ContextualSegmentID: this.state.ID,
        TargetingSegment: '',
        TargetingSegmentIsAllowed: EAllowStatus.DENY,
        ThirdParty: ThirdPartyIAS,
        IrisPartner: IrisPartnerUnknown,
      } as IThirdPartyContextualSegment;
      const ThirdPartyContextualSegments = cloneDeep(this.state.ThirdPartyContextualSegments);
      ThirdPartyContextualSegments.push(newThirdPartyContextualSegment);

      const thirdPartyContextualSegmentsList = cloneDeep(
        this.state.thirdPartyContextualSegmentsList,
      );
      thirdPartyContextualSegmentsList.push(generateIASContextualSegmentList([]));

      this.setState({
        ThirdPartyContextualSegments,
        thirdPartyContextualSegmentsList,
      });
    };

    // -------- SNACKBAR HELPER FUNCTIONS -------- //
    handleSnackbarError = (snackbarError: boolean, snackbarMessage: string): void => {
      this.setState({
        snackbarError,
        snackbarMessage,
      });
    };

    handleSnackbarClose = (): void => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    // -------- RENDER HELPER FUNCTIONS -------- //
    // NOTE: We destructure props and states used in render functions to clearly
    // show what we are passing as well as keeping the code clean and easier to read

    renderAppBar(): ReactElement {
      const { ID, Name, updating } = this.state;

      return (
        <Grid item>
          <SettingsAppBar
            name={this.isUserInfoMasked() ? `Contextual_Segment_${ID}` : Name}
            isActive={this.state.Active === ResourceActiveEnabled}
            hasWriteRights={this.hasWriteRights().isAuthorized}
            isUpdating={updating}
            handleNameChange={this.handleNameChange}
            handleSave={this.handleSave}
            handleClose={this.handleClose}
            handleDelete={this.handleDelete}
            handleChangeActive={this.handleChangeActive}
            relative
          />
        </Grid>
      );
    }

    renderSlider = (): ReactElement => {
      return (
        <Slider
          defaultValue={[this.state.MinContentLength, this.state.MaxContentLength]}
          min={NO_MIN_CONTENT_LENGTH}
          max={NO_MAX_CONTENT_LENGTH}
          marks={[
            {
              value: NO_MIN_CONTENT_LENGTH,
              label: '0',
            },
            {
              value: 6,
              label: '6',
            },
            {
              value: 15,
              label: '15',
            },
            {
              value: 30,
              label: '30',
            },
            {
              value: 45,
              label: '45',
            },
            {
              value: 60,
              label: '60',
            },
            {
              value: 90,
              label: '90',
            },
            {
              value: 120,
              label: '120',
            },
            {
              value: 150,
              label: '150',
            },
            {
              value: 180,
              label: '180',
            },
            {
              value: NO_MAX_CONTENT_LENGTH, // I have to use 210 as no max since the slider is to scale
              label: 'No Max',
            },
          ]}
          step={null}
          onChange={(_e, newValues) => this.handleChangeSliderSelection(newValues)}
          style={{
            width: '100%',
            color: 'rgb(9, 174, 130)',
          }}
        />
      );
    };

    renderThirdPartySegments = (): ReactElement => {
      return (
        <Grid item style={{ width: '100%', marginLeft: 32 }}>
          <Grid container direction='column'>
            <Grid item className={this.props.classes.maxWidthGrid}>
              <Grid container direction='row' spacing={4} alignItems='center'>
                <Grid item>
                  <Typography className={this.props.classes.typographyFontBold}>
                    Contextual Data Partners
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {this.state.ThirdPartyContextualSegments.length > 0 && (
              <Grid item className={this.props.classes.maxWidthGrid} style={{ marginLeft: 15 }}>
                <Grid container direction='row' spacing={4} alignItems='center'>
                  <Grid item xs={3}>
                    <Tooltip
                      title={`If "OR" is selected, a single Data Partner must match the its targeting and if "AND" is selected all Data Partners must match their targeting.`}
                    >
                      <Typography className={this.props.classes.typographyFont}>
                        Partner Targeting
                      </Typography>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={8} style={{ marginLeft: -20 }}>
                    <FormControl component='fieldset'>
                      <RadioGroup
                        row
                        aria-label='position'
                        name='ThirdPartyTargetingType'
                        defaultValue='top'
                        value={this.state.ThirdPartyTargetingType}
                        onChange={this.handleChange}
                      >
                        <Tooltip title='A single Contextual Data Partner must match the given targeting'>
                          <FormControlLabel
                            value={SegmentTargetingOR}
                            control={<Radio color='primary' size='small' />}
                            label={
                              <Typography className={this.props.classes.formControlLabel}>
                                Or
                              </Typography>
                            }
                            labelPlacement='top'
                          />
                        </Tooltip>
                        <Tooltip title='All Contextual Data Partners must match'>
                          <FormControlLabel
                            value={SegmentTargetingAND}
                            control={<Radio color='primary' size='small' />}
                            label={
                              <Typography className={this.props.classes.formControlLabel}>
                                And
                              </Typography>
                            }
                            labelPlacement='top'
                          />
                        </Tooltip>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {this.state.ThirdPartyContextualSegments.map(
              (thirdPartyContextualSegment, idx: number) => {
                const selectedIDs = findSelectedIDs(
                  this.state.thirdPartyContextualSegmentsList[idx],
                );
                return (
                  <Grid item className={this.props.classes.maxWidthGrid}>
                    <ModelPrimaryContainerV2>
                      <Grid container direction='column' spacing={2}>
                        <Grid item className={this.props.classes.maxWidthMaxHeightGrid}>
                          <Grid container direction='row' alignItems='center' spacing={4}>
                            <Grid item xs={3} style={{ marginLeft: 15 }}>
                              <Typography className={this.props.classes.typographyFont}>
                                Data Source
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Select
                                name='ThirdParty'
                                style={{ fontSize: 14, minWidth: 150 }}
                                value={thirdPartyContextualSegment.ThirdParty}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  this.handleChangeThirdParty(parseInt(e.target.value, 10), idx)
                                }
                              >
                                {generateThirdPartyMenu(
                                  hasRoleSuperUser(this.props.user.user),
                                  this.props.session.publisher,
                                ).map((item) => {
                                  return <MenuItem value={item.key}>{item.text}</MenuItem>;
                                })}
                              </Select>
                            </Grid>
                            {thirdPartyContextualSegment.ThirdParty === ThirdPartyIris ? (
                              <Grid item xs={1} style={{ marginLeft: 15 }}>
                                <Typography className={this.props.classes.typographyFont}>
                                  Partner
                                </Typography>
                              </Grid>
                            ) : (
                              <Grid item xs={1} style={{ marginLeft: 15 }} />
                            )}
                            {thirdPartyContextualSegment.ThirdParty === ThirdPartyIris ? (
                              <Grid item xs={3}>
                                <Select
                                  name='IrisPartners'
                                  style={{ fontSize: 14, minWidth: 150 }}
                                  value={thirdPartyContextualSegment.IrisPartner}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    this.handleChangeIrisPartner(parseInt(e.target.value, 10), idx)
                                  }
                                >
                                  {generateIrisPartnersMenu().map((item) => {
                                    return <MenuItem value={item.key}>{item.text}</MenuItem>;
                                  })}
                                </Select>
                              </Grid>
                            ) : (
                              <Grid item xs={3} />
                            )}
                            <Grid item xs={1}>
                              <DeleteIcon
                                onClick={() => this.handleDeleteThirdPartyContextualSegment(idx)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {thirdPartyContextualSegment.ThirdParty === ThirdPartyComscore && (
                          <Grid item className={this.props.classes.maxWidthGrid}>
                            <ComscoreContextualSelector
                              classes={this.props.classes}
                              selectedIDs={selectedIDs}
                              onToggleID={(selectedIDs: string[]) => {
                                const thirdPartyContextualSegmentsList = cloneDeep(
                                  this.state.thirdPartyContextualSegmentsList,
                                );
                                thirdPartyContextualSegmentsList[idx] =
                                  generateThirdPartyContextualSegmentList(
                                    ThirdPartyComscore,
                                    undefined,
                                    selectedIDs,
                                  );
                                this.setState({
                                  thirdPartyContextualSegmentsList,
                                });
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item className={this.props.classes.maxWidthGrid}>
                          <Grid container direction='row' alignItems='center' spacing={4}>
                            <Grid item xs={3} style={{ marginLeft: 15 }}>
                              <Typography className={this.props.classes.typographyFont}>
                                Contextual Segment
                              </Typography>
                            </Grid>
                            <Grid item xs={1}>
                              <ConfirmationDialogButton
                                title='Targeting Change'
                                description={makeTargetingChangeDescription(
                                  thirdPartyContextualSegment.TargetingSegmentIsAllowed ===
                                    EAllowStatus.ALLOW,
                                )}
                                triggerComponentInfo={makeTargetingChangeInfoHover(
                                  thirdPartyContextualSegment.TargetingSegmentIsAllowed ===
                                    EAllowStatus.ALLOW,
                                )}
                                acceptButtonTitle='Confirm'
                                acceptButtonCallBack={() =>
                                  this.handleChange(
                                    {
                                      target: {
                                        name: 'TargetingSegmentIsAllowed',
                                        value: reverseEAllowStatus(
                                          thirdPartyContextualSegment.TargetingSegmentIsAllowed,
                                        ) as any,
                                      },
                                    } as any,
                                    idx,
                                  )
                                }
                                refuseButtonTitle='Cancel'
                              >
                                <IconButton>
                                  {thirdPartyContextualSegment.TargetingSegmentIsAllowed ===
                                  EAllowStatus.ALLOW ? (
                                    <CheckIcon style={{ color: publicaColors.green }} />
                                  ) : (
                                    <BlockIcon style={{ color: publicaColors.red }} />
                                  )}
                                </IconButton>
                              </ConfirmationDialogButton>
                            </Grid>
                            <Grid item xs={7}>
                              <AutocompleteDropdown
                                selectedIDs={selectedIDs}
                                list={this.state.thirdPartyContextualSegmentsList[idx]}
                                field='thirdPartyContextualSegmentsList'
                                placeholderText='Select Contextual Segments'
                                handleChange={(newList: IMenuList, field: string) =>
                                  this.handleChangeList(newList, field, idx)
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </ModelPrimaryContainerV2>
                    {idx !== this.state.ThirdPartyContextualSegments.length - 1 && (
                      <Grid
                        item
                        container
                        className={this.props.classes.maxWidthGrid}
                        justify='center'
                      >
                        <Grid item style={{ marginTop: 10 }}>
                          <Typography className={this.props.classes.typographyFontBold}>
                            {this.state.ThirdPartyTargetingType === SegmentTargetingOR
                              ? 'OR'
                              : 'AND'}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                );
              },
            )}
            <Grid item className={this.props.classes.maxWidthGrid} style={{ marginTop: 15 }}>
              <Grid container direction='row' spacing={4}>
                <Grid item>
                  <Typography
                    className={this.props.classes.addTypography}
                    onClick={this.handleAddThirdPartyContextualSegment}
                  >
                    + Contextual Data Partner
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderContextualSegmentsForecast = (): ReactElement => {
      const { classes } = this.props;
      const { forecast, runningForecast, schedulingForecast } = this.state;
      return (
        <Grid item style={{ width: '100%', marginLeft: 32 }}>
          <Grid container direction='column'>
            <Grid>
              <div className={classes.section}>
                <div
                  style={{
                    display: 'flex',
                    marginTop: '40px',
                  }}
                >
                  <FlagIcon />
                  &nbsp;&nbsp;
                  <Typography style={{ fontWeight: 500 }}>Forecasting Tool</Typography>
                </div>
                <p>
                  Forecasting takes historical data from the previous 30 days of data to estimate
                  metrics given the current contextual segment settings.
                </p>
                <Grid container direction='column'>
                  <Grid item className={classes.maxWidthGrid}>
                    <Tooltip title=''>
                      <span>
                        <ModelPrimaryButton
                          variant='contained'
                          disabled={runningForecast}
                          onClick={this.runForecast}
                          style={{
                            marginBottom: '12px',
                            marginRight: '8px',
                          }}
                        >
                          {runningForecast && (
                            <div>
                              <CircularProgress size={20} />
                              &nbsp;&nbsp;
                            </div>
                          )}
                          Run Forecast
                        </ModelPrimaryButton>
                      </span>
                    </Tooltip>
                    <Tooltip title=''>
                      <span>
                        <ModelPrimaryButton
                          variant='contained'
                          disabled={schedulingForecast}
                          onClick={this.scheduleForecast}
                          style={{
                            marginBottom: '12px',
                            marginRight: '8px',
                          }}
                        >
                          {schedulingForecast && (
                            <div>
                              <CircularProgress size={20} />
                              &nbsp;&nbsp;
                            </div>
                          )}
                          Email Forecast
                        </ModelPrimaryButton>
                      </span>
                    </Tooltip>
                    {forecast && forecast.Success && (
                      <div>
                        <Paper className={classes.table}>
                          <Table size='small'>
                            <TableBody>
                              <TableRow>
                                <TableCell component='th'>
                                  <strong>Impressions</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Endpoint Requests</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>CPM</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Revenue</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Notes From Forecaster</strong>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  className={forecast.Success ? classes.success : classes.danger}
                                >
                                  {(forecast.BidderImpressions || 0).toLocaleString(
                                    navigator.language,
                                  )}
                                </TableCell>
                                <TableCell
                                  className={forecast.Success ? classes.success : classes.danger}
                                >
                                  {(forecast.EndpointRequests || 0).toLocaleString(
                                    navigator.language,
                                  )}
                                </TableCell>
                                <TableCell
                                  className={forecast.Success ? classes.success : classes.danger}
                                >
                                  {(forecast.CPM || 0.0).toLocaleString(navigator.language, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </TableCell>
                                <TableCell
                                  className={forecast.Success ? classes.success : classes.danger}
                                >
                                  {(forecast.Revenue || 0.0).toLocaleString(navigator.language, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </TableCell>
                                <TableCell
                                  className={forecast.Success ? classes.success : classes.danger}
                                >
                                  {forecast.ForecastNotes}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </Paper>
                      </div>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderDelivery = (): ReactElement => {
      return (
        <>
          <Grid item style={{ width: '100%', marginTop: 10, marginLeft: 32 }}>
            <Grid container direction='column' spacing={2}>
              <Grid item className={this.props.classes.maxWidthGrid}>
                <Grid container direction='row' spacing={4} alignItems='center'>
                  <Grid item>
                    <Typography className={this.props.classes.typographyFontBold}>
                      Endpoint Request Data
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item className={this.props.classes.maxWidthGrid}>
                <Grid container direction='row' alignItems='center' spacing={4}>
                  <Grid item xs={3} style={{ marginLeft: 15 }}>
                    <Typography className={this.props.classes.typographyFont}>
                      Content Rating
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <ConfirmationDialogButton
                      title='Targeting Change'
                      description={makeTargetingChangeDescription(
                        this.state.TargetingContentRatingIsAllowed === EAllowStatus.ALLOW,
                      )}
                      triggerComponentInfo={makeTargetingChangeInfoHover(
                        this.state.TargetingContentRatingIsAllowed === EAllowStatus.ALLOW,
                      )}
                      acceptButtonTitle='Confirm'
                      acceptButtonCallBack={() =>
                        this.handleChange({
                          target: {
                            name: 'TargetingContentRatingIsAllowed',
                            value: reverseEAllowStatus(
                              this.state.TargetingContentRatingIsAllowed,
                            ) as any,
                          },
                        } as any)
                      }
                      refuseButtonTitle='Cancel'
                    >
                      <IconButton>
                        {this.state.TargetingContentRatingIsAllowed === EAllowStatus.ALLOW ? (
                          <CheckIcon style={{ color: publicaColors.green }} />
                        ) : (
                          <BlockIcon style={{ color: publicaColors.red }} />
                        )}
                      </IconButton>
                    </ConfirmationDialogButton>
                  </Grid>
                  <Grid item xs={7}>
                    <AutocompleteDropdown
                      list={this.state.contentRatingList}
                      field='contentRatingList'
                      placeholderText='Select Targeted Content Ratings'
                      handleChange={this.handleChangeList}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={this.props.classes.maxWidthGrid}>
                <Grid container direction='row' alignItems='center' spacing={4}>
                  <Grid item xs={3} style={{ marginLeft: 15 }}>
                    <Typography className={this.props.classes.typographyFont}>
                      Content Genre
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <ConfirmationDialogButton
                      title='Targeting Change'
                      description={makeTargetingChangeDescription(
                        this.state.TargetingContentGenreIsAllowed === EAllowStatus.ALLOW,
                      )}
                      triggerComponentInfo={makeTargetingChangeInfoHover(
                        this.state.TargetingContentGenreIsAllowed === EAllowStatus.ALLOW,
                      )}
                      acceptButtonTitle='Confirm'
                      acceptButtonCallBack={() =>
                        this.handleChange({
                          target: {
                            name: 'TargetingContentGenreIsAllowed',
                            value: reverseEAllowStatus(
                              this.state.TargetingContentGenreIsAllowed,
                            ) as any,
                          },
                        } as any)
                      }
                      refuseButtonTitle='Cancel'
                    >
                      <IconButton>
                        {this.state.TargetingContentGenreIsAllowed === EAllowStatus.ALLOW ? (
                          <CheckIcon style={{ color: publicaColors.green }} />
                        ) : (
                          <BlockIcon style={{ color: publicaColors.red }} />
                        )}
                      </IconButton>
                    </ConfirmationDialogButton>
                  </Grid>
                  <Grid item xs={7}>
                    <AutocompleteDropdown
                      list={this.state.contentGenreList}
                      field='contentGenreList'
                      placeholderText='Select Targeted Content Genres'
                      handleChange={this.handleChangeList}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={this.props.classes.maxWidthGrid}>
                <Grid container direction='row' alignItems='center' spacing={4}>
                  <Grid item xs={3} style={{ marginLeft: 15 }}>
                    <Typography className={this.props.classes.typographyFont}>
                      Content Collection
                      <Tooltip
                        title='This feature is a collection of content IDs, which will be targeted through the custom_10 field. Talk to your account manager for options on targeting a content collection.'
                        placement='bottom-start'
                      >
                        <InfoIcon
                          style={{
                            verticalAlign: 'bottom',
                            width: '1rem',
                            color: '#929599',
                            paddingTop: '3px',
                            marginLeft: '5px',
                          }}
                        />
                      </Tooltip>
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <CheckIcon style={{ color: publicaColors.green, marginLeft: 10 }} />
                  </Grid>
                  <Grid item xs={5}>
                    <MaterialSearchDropdownMulti
                      enableMultiSelect={false}
                      menuTitle='Collection'
                      selectAll={false}
                      list={this.state.contentCollectionList}
                      onChange={(list: IMenuList) => {
                        const selectedID = findSelectedIDs(list);
                        const selectedContentCollection = this.state.contentCollections.find(
                          (item) => item.ID === Number(selectedID[0]),
                        );
                        if (selectedContentCollection) {
                          this.setState({
                            contentCollectionList: list,
                            selectedContentCollection,
                            ContentCollectionID: selectedContentCollection.ID,
                          });
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <ModelSecondaryButton
                      onClick={() => {
                        this.setState({
                          openContentCollectionDialog: true,
                          startingManageCollectionTab: 0,
                        });
                      }}
                      disabled={false}
                    >
                      Manage Collections
                    </ModelSecondaryButton>
                    {/* Open and Close different dialogs for Content Collections */}
                    {this.state.openContentCollectionDialog && this.renderManageCollectionDialog()}
                    {this.state.openCreateCollectionDialog && this.renderCreateCollectionDialog()}
                    {this.state.openCreateCollectionDataDialog &&
                      this.renderCreateCollectionDataDialog()}
                    {this.state.openEditCollectionDialog && this.renderEditCollectionDialog()}
                    {this.state.openEditCollectionDataDialog &&
                      this.renderEditCollectionDataDialog()}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={this.props.classes.maxWidthMaxHeightGrid}>
                <Grid container direction='row' alignItems='center' spacing={2}>
                  <Grid item xs={3} style={{ marginLeft: 15 }}>
                    <Typography className={this.props.classes.typographyFont}>
                      Content Length (minutes)
                    </Typography>
                  </Grid>
                  <Grid item xs={1} />
                  <Grid item xs={7}>
                    {this.renderSlider()}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={this.props.classes.maxWidthMaxHeightGrid}>
                <Grid container direction='row' alignItems='center' spacing={2}>
                  <Grid item xs={3} style={{ marginLeft: 15 }}>
                    <Typography className={this.props.classes.typographyFont}>
                      Segment Labels
                    </Typography>
                  </Grid>
                  <Grid item xs={1} />
                  <Grid item xs={7}>
                    <AutocompleteDropdown
                      list={this.state.contextualSegmentLabelsList}
                      field='contextualSegmentLabelsList'
                      placeholderText='Enter Segment Labels'
                      handleChange={this.handleChangeList}
                      handleAddNewValue={this.handleAddSegmentLabel}
                      freeSolo={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Content Viewability */}
          {hasRoleSuperUser(this.props.user.user) && (
            <Grid item style={{ width: '100%', marginTop: 10, marginLeft: 32 }}>
              <Grid container direction='column' spacing={2}>
                <Grid item className={this.props.classes.maxWidthGrid}>
                  <Grid container direction='row' spacing={4} alignItems='center'>
                    <Grid item>
                      <Typography className={this.props.classes.typographyFontBold}>
                        Content Viewability *
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item className={this.props.classes.maxWidthGrid}>
                  <Grid container direction='row' alignItems='center' spacing={4}>
                    <Grid item xs={3} style={{ marginLeft: 15 }}>
                      <Typography className={this.props.classes.typographyFont}>
                        Only target apps certified for Fully On-Screen
                      </Typography>
                    </Grid>
                    <Grid item xs={1} />
                    <Grid item xs={7}>
                      <Switch
                        checked={this.state.OnlyTargetCertifiedFullyOnScreen === EBool.EBool_TRUE}
                        onChange={() =>
                          this.setState({
                            OnlyTargetCertifiedFullyOnScreen:
                              this.state.OnlyTargetCertifiedFullyOnScreen === EBool.EBool_TRUE
                                ? EBool.EBool_FALSE
                                : EBool.EBool_TRUE,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.renderThirdPartySegments()}
          {this.renderContextualSegmentsForecast()}
        </>
      );
    };

    // define tabs and corresponding render functions
    renderTabs(): ReactElement {
      const { user } = this.props;
      const { startingTab } = this.state;
      const tabs: ITab[] = [
        {
          label: 'Delivery',
          render: this.renderDelivery,
        },
      ];
      return (
        <Grid style={{ marginTop: 50 }}>
          <SettingsTabs
            tabs={tabs}
            marginTop={0}
            maxTabWidth='1200px'
            startingTab={startingTab}
            enableTrackEvents={true}
            user={user.user}
            resource='ContextualSegments'
          />
        </Grid>
      );
    }

    renderManageCollectionDialog = () => {
      const { openContentCollectionDialog, startingManageCollectionTab } = this.state;

      const tabs: ITab[] = [
        {
          label: 'Overview',
          render: this.renderCollectionOverview,
        },
        {
          label: 'Manage Collection',
          render: this.renderManageCollection,
        },
      ];

      const onCloseFn = (openDialog?: boolean) => {
        this.setState({
          openContentCollectionDialog: !!openDialog,
        });
      };

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openContentCollectionDialog}
          onClose={() => this.setState({ openContentCollectionDialog: false })}
        >
          <DialogTitle
            style={{
              paddingTop: 50,
              paddingRight: 50,
              paddingLeft: 50,
            }}
          >
            Collection Builder
            <DialogContentText id='alert-dialog-description'>
              Update targeting list by uploading a new CSV file with content IDs. Edit or delete
              content in the table.
            </DialogContentText>
          </DialogTitle>
          <DialogContent>
            <SettingsTabs
              tabs={tabs}
              marginTop={0}
              maxTabWidth='1200px'
              startingTab={startingManageCollectionTab}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderCollectionOverview = (): ReactElement => {
      const { contentCollectionMapData, loading, updating } = this.state;

      const columns: IListTableColumn[] = [
        { field: 'Name', title: 'Collection Name', renderType: 'normal' },
        { field: 'CollectionTitles', title: 'Titles', renderType: 'normal' },
        { field: 'Actions', title: 'Actions', renderType: 'actions', searchable: false },
      ];

      return (
        <Grid item className={this.props.classes.maxWidthGrid} style={{ height: 450 }}>
          <ListTable
            title=''
            columns={columns}
            data={contentCollectionMapData}
            isLoading={loading}
            isUpdating={updating}
            handleSetUpdating={this.handleSetUpdatingContentCollections}
            handleOpenModal3={this.openEditCollection}
            handleDeleteItem={this.deleteCollection}
            pageSize={10}
            useCustomAddButton={true}
            renderCustomToolbar={(props: any) => this.renderCollectionOverviewAddRow(props)}
          />
        </Grid>
      );
    };

    isStringNumeric = (input: string): boolean => {
      // Use a regular expression to match only numeric characters (0-9)
      const numericRegex = /^[0-9]+$/;

      // Test the input string against the regular expression
      return numericRegex.test(input);
    };

    renderManageCollection = (): ReactElement => {
      const { contentCollectionDataMapData, loading, updating } = this.state;

      const columns: IListTableColumn[] = [
        { field: 'Custom10Targeting', title: 'Content ID', renderType: 'normal' },
        { field: 'Custom10TargetingAlias', title: 'Content Title', renderType: 'normal' },
        { field: 'Actions', title: 'Actions', renderType: 'actions' },
      ];

      return (
        <Grid item className={this.props.classes.maxWidthGrid} style={{ height: 450 }}>
          <ListTable
            title=''
            columns={columns}
            data={contentCollectionDataMapData}
            isLoading={loading}
            isUpdating={updating}
            handleSetUpdating={this.handleSetUpdatingContentCollectionData}
            handleOpenModal3={this.openEditCollectionData}
            handleDeleteItem={this.deleteCollectionData}
            pageSize={10}
            actionsColumnIndex={2}
            useCustomAddButton={true}
            renderCustomToolbar={(props: any) =>
              this.renderListToolbarUploadDownloadCSV(
                props,
                genDownloadCollectionDataCSVURL(
                  this.props.session.publisher.ID,
                  this.state.manageCollectionSelectedID,
                ),
                this.uploadCollectionDataMapPair,
              )
            }
          />
        </Grid>
      );
    };

    handleSetUpdatingContentCollections = (updatingContentCollections: boolean) => {
      this.setState({ updatingContentCollections });
    };

    handleSetUpdatingContentCollectionData = (updatingContentCollectionData: boolean) => {
      this.setState({ updatingContentCollectionData });
    };

    renderCollectionOverviewAddRow = (props: any) => {
      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '180px' },
      };

      return (
        <Grid container>
          <Grid item style={{ marginLeft: 10, marginTop: 10, width: 'inherit' }}>
            <Grid container direction='row' justify='space-between' alignItems='center' spacing={2}>
              {/* Buttons */}
              <Grid item xs={6} style={{ paddingTop: 25, paddingBottom: 40 }}>
                <Button
                  style={{ color: publicaColors.blue }}
                  variant='text'
                  component='a'
                  target='_blank'
                  rel='noopener'
                  onClick={() => {
                    this.setState({
                      openContentCollectionDialog: false,
                      openCreateCollectionDialog: true,
                      startingManageCollectionTab: 0,
                    });
                    this.addContentCollection();
                  }}
                >
                  + Add New
                </Button>
              </Grid>
              {/* search bar - grid with class "MTableToolbarWrapper" is required for auto focusing search bar on load */}
              <Grid item xs={6} className='MTableToolbarWrapper'>
                <MTableToolbar {...copyProps} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // Creates an empty record in the Content Collections
    // We populate that empty record when we are creating a new entry
    addContentCollection = () => {
      const { session } = this.props;
      // push an empty collection to state
      this.setState(
        {
          contentCollections: update(this.state.contentCollections, {
            $push: [
              {
                PublisherID: session.publisher.ID,
                ID: 0,
                Name: '',
              },
            ],
          }),
        },
        () => {
          this.setState({
            newContentCollectionActive: true, // boolean to determine if ContentCollection is being created
            contentCollectionDialogActive: true, // boolean to determine if the ContentCollection dialog is opened
            contentCollectionDialogID: 0, // integer ID to determine what info to show in the dialog
          });
        },
      );
    };

    // Creates an empty record in the Content Collection Data
    // We populate that empty record when we are creating a new entry
    addContentCollectionData = () => {
      this.setState(
        {
          contentCollectionData: update(this.state.contentCollectionData, {
            $push: [
              {
                ID: 0,
                Custom10Targeting: '',
                Custom10TargetingAlias: '',
              },
            ],
          }),
        },
        () => {
          this.setState({
            newContentCollectionDataActive: true, // boolean to determine if ContentCollectionData is being created
            contentCollectionDataDialogActive: true, // boolean to determine if the ContentCollectionData  dialog is opened
            contentCollectionDataDialogID: 0, // integer ID to determine what info to show in the dialog
          });
        },
      );
    };
    // Renders Manage Collections Tab in Collections Dropdown
    renderListToolbarUploadDownloadCSV = (
      props: any,
      genDownloadURL: string,
      uploadCSVFunc: (event: React.ChangeEvent<HTMLInputElement>) => void,
    ) => {
      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '180px' },
      };

      return (
        <Grid container>
          <Grid item style={{ marginLeft: 10, marginTop: 10, width: 'inherit' }}>
            <Grid container direction='row' justify='space-between' alignItems='center' spacing={2}>
              {/* Buttons */}
              <Grid item xs={2}>
                <Typography className={this.props.classes.typographyFont}>Collection</Typography>
              </Grid>
              <Grid item xs={3}>
                <MaterialSearchDropdownMulti
                  enableMultiSelect={false}
                  menuTitle='Collection'
                  selectAll={false}
                  list={this.state.manageCollectionList}
                  onChange={(list: IMenuList) => {
                    const selectedID = findSelectedIDs(list);
                    const manageCollectionSelectedID = Number(selectedID[0]);
                    this.genContentCollectionDataTableData(
                      manageCollectionSelectedID,
                      this.state.contentCollections,
                    );
                    this.setState({
                      manageCollectionList: list,
                      manageCollectionSelectedID,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              {/* search bar - grid with class "MTableToolbarWrapper" is required for auto focusing search bar on load */}
              <Grid item xs={4}></Grid>
            </Grid>
            <Grid
              container
              direction='row'
              justify='space-between'
              alignItems='center'
              spacing={2}
              style={{ paddingBottom: 20 }}
            >
              {/* Buttons */}
              <Grid item xs={3}>
                <Button
                  style={{
                    color:
                      this.state.manageCollectionSelectedID !== 0
                        ? publicaColors.blue
                        : publicaColors.gray,
                  }}
                  variant='text'
                  component='a'
                  target='_blank'
                  rel='noopener'
                  disabled={this.state.manageCollectionSelectedID === 0}
                  onClick={() => {
                    this.setState({
                      openContentCollectionDialog: false,
                      openCreateCollectionDataDialog: true,
                      startingManageCollectionTab: 1,
                    });
                    this.addContentCollectionData();
                  }}
                >
                  + Add Row
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  style={{ color: publicaColors.blue }}
                  variant='text'
                  component='a'
                  startIcon={<GetAppIcon />}
                  target='_blank'
                  rel='noopener'
                  href={genDownloadURL}
                >
                  Download CSV
                </Button>
              </Grid>
              <Grid item xs={3}>
                <label>
                  <input
                    type='file'
                    style={{ display: 'none' }}
                    accept='.csv'
                    onChange={uploadCSVFunc}
                  />
                  <Button
                    style={{
                      color:
                        this.state.manageCollectionSelectedID !== 0
                          ? publicaColors.blue
                          : publicaColors.gray,
                    }}
                    variant='text'
                    component='span'
                    startIcon={<PublishIcon />}
                    disabled={this.state.manageCollectionSelectedID === 0}
                  >
                    Upload CSV
                  </Button>
                </label>
              </Grid>
              {/* search bar - grid with class "MTableToolbarWrapper" is required for auto focusing search bar on load */}
              <Grid item xs={3} className='MTableToolbarWrapper'>
                <MTableToolbar {...copyProps} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // Upload collection Data CSV
    uploadCollectionDataMapPair = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { target } = event;
      if (target.files && target.files.length > 0) {
        const file = target.files[0];
        const filenameParams = file.name.split('.');
        const ext = filenameParams[filenameParams.length - 1];
        if (ext.toLowerCase() !== 'csv') {
          this.setState({
            snackbarMessage: 'Only CSV files are supported',
            snackbarError: true,
          });
          return;
        }

        uploadCollectionDataCSVfile({
          publisher_id: this.props.session.publisher.ID,
          collection_id: this.state.manageCollectionSelectedID,
          name: filenameParams[0],
          file,
        })
          .then((json: any) => {
            if (json.response && json.response.errors) {
              this.setState({
                snackbarMessage: `CSV Upload failed: ${json.response.errors}`,
                snackbarError: true,
              });
            } else {
              this.setState({
                snackbarMessage: 'CSV Upload successful',
              });
            }
            this.genContentCollections();
          })
          .catch(() => {
            this.setState({
              snackbarMessage: 'CSV Upload failed',
              snackbarError: true,
            });
          });
      }
      // reset the value of the event so the same file name can be uploaded
      event.target.value = '';
    };
    renderCreateCollectionDialog = () => {
      const { openCreateCollectionDialog, newCollectionName } = this.state;
      const { classes } = this.props;

      const onCloseFn = (openDialog?: boolean) => {
        this.setState({
          openCreateCollectionDialog: !!openDialog,
          openContentCollectionDialog: true,
          newCollectionName: '',
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = {} as IErrors;

        if (newCollectionName === '') {
          errors.CollectionDataName = 'Please insert a Collection Name';
        }
        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: `Please fix errors before saving collection: ${errorText}`,
              snackbarError: true,
            },
            () => {
              setTimeout(this.handleSnackbarClose, 5000);
            },
          );
          return;
        }
        this.handleAddNewCollection();
        this.setState({
          openCreateCollectionDialog: !!openDialog,
          openContentCollectionDialog: true,
          newCollectionName: '',
        });
      };

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Collection Name',
        field1: 'newCollectionName',
        value1: newCollectionName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openCreateCollectionDialog}
          onClose={() => this.setState({ openCreateCollectionDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>Create Collection</DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section} style={{ paddingBottom: 20 }}>
              <InputRow rowInfo={NameRow} disableEdit={false} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              Create
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderEditCollectionDialog = () => {
      const { openEditCollectionDialog, editCollectionID } = this.state;
      const { newCollectionName } = this.state;
      const { classes } = this.props;

      const onCloseFn = (openDialog?: boolean) => {
        this.setState({
          openEditCollectionDialog: !!openDialog,
          openContentCollectionDialog: true,
          startingManageCollectionTab: 0,
          newCollectionName: '',
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = {} as IErrors;

        if (newCollectionName === '') {
          errors.CollectionDataName = 'Please insert a Collection Name';
        }
        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: `Please fix errors before saving collection: ${errorText}`,
              snackbarError: true,
            },
            () => {
              setTimeout(this.handleSnackbarClose, 5000);
            },
          );
          return;
        }
        this.handleEditCollections(editCollectionID, newCollectionName);
        this.setState({
          openEditCollectionDialog: !!openDialog,
          openContentCollectionDialog: true,
          startingManageCollectionTab: 0,
          newCollectionName: '',
        });
      };

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Collection Name',
        field1: 'newCollectionName',
        value1: newCollectionName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openEditCollectionDialog}
          onClose={() => this.setState({ openEditCollectionDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>Edit Collection</DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section} style={{ paddingBottom: 20 }}>
              <InputRow rowInfo={NameRow} disableEdit={false} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderEditCollectionDataDialog = () => {
      const {
        openEditCollectionDataDialog,
        editCollectionDataID,
        newCollectionDataName,
        newCollectionDataID,
      } = this.state;
      const { classes } = this.props;

      const onCloseFn = (openDialog?: boolean) => {
        this.setState({
          openEditCollectionDataDialog: !!openDialog,
          openContentCollectionDialog: true,
          startingManageCollectionTab: 1,
          newCollectionDataName: '',
          newCollectionDataID: '',
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = {} as IErrors;

        if (!this.isStringNumeric(newCollectionDataID)) {
          errors.CollectionDataID = 'ID Should be a numeric value';
        }
        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: `Please fix errors before saving collection: ${errorText}`,
              snackbarError: true,
            },
            () => {
              setTimeout(this.handleSnackbarClose, 5000);
            },
          );
          return;
        }
        this.handleEditCollectionData(
          editCollectionDataID,
          newCollectionDataName,
          Number(newCollectionDataID),
        );
        this.setState({
          openEditCollectionDataDialog: !!openDialog,
          openContentCollectionDialog: true,
          startingManageCollectionTab: 1,
          newCollectionDataName: '',
          newCollectionDataID: '',
        });
      };

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Content Title',
        field1: 'newCollectionDataName',
        value1: newCollectionDataName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;

      const IDRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Content ID',
        field1: 'newCollectionDataID',
        value1: newCollectionDataID,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openEditCollectionDataDialog}
          onClose={() => this.setState({ openEditCollectionDataDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>Edit Collection Item</DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section}>
              <InputRow rowInfo={NameRow} disableEdit={false} />
            </Grid>
            <Grid className={classes.section} style={{ paddingBottom: 20 }}>
              <InputRow rowInfo={IDRow} disableEdit={false} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    openEditCollection = (collectionID: number) => {
      this.setState({
        openContentCollectionDialog: false,
        editCollectionID: collectionID,
        openEditCollectionDialog: true,
        newCollectionName: this.state.contentCollectionList[collectionID].title,
      });

      return Promise.resolve();
    };

    openEditCollectionData = (collectionID: number) => {
      const selectedCollectionData = this.state.contentCollectionDataMapData.find(
        (item) => item.ID === collectionID,
      );
      if (selectedCollectionData) {
        this.setState({
          openContentCollectionDialog: false,
          editCollectionDataID: collectionID,
          openEditCollectionDataDialog: true,
          newCollectionDataName: selectedCollectionData.Custom10TargetingAlias,
          newCollectionDataID: selectedCollectionData.Custom10Targeting.toString(),
        });
      }
      return Promise.resolve();
    };

    renderCreateCollectionDataDialog = () => {
      const { openCreateCollectionDataDialog, newCollectionDataName, newCollectionDataID } =
        this.state;
      const { classes } = this.props;

      const onCloseFn = (openDialog?: boolean) => {
        this.setState({
          openCreateCollectionDataDialog: !!openDialog,
          openContentCollectionDialog: true,
          newCollectionDataName: '',
          newCollectionDataID: '',
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = {} as IErrors;

        if (!this.isStringNumeric(newCollectionDataID)) {
          errors.CollectionDataID = 'ID Should be a numeric value';
        }
        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: `Please fix errors before saving collection: ${errorText}`,
              snackbarError: true,
            },
            () => {
              setTimeout(this.handleSnackbarClose, 5000);
            },
          );
          return;
        }
        this.handleAddNewCollectionData();
        this.setState({
          openCreateCollectionDataDialog: !!openDialog,
          openContentCollectionDialog: true,
          newCollectionDataName: '',
          newCollectionDataID: '',
        });
      };

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Content Title',
        field1: 'newCollectionDataName',
        value1: newCollectionDataName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;

      const IDRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Content ID',
        field1: 'newCollectionDataID',
        value1: newCollectionDataID,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openCreateCollectionDataDialog}
          onClose={() => this.setState({ openCreateCollectionDataDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>Create Collection Item</DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section}>
              <InputRow rowInfo={NameRow} disableEdit={false} />
            </Grid>
            <Grid className={classes.section} style={{ paddingBottom: 20 }}>
              <InputRow rowInfo={IDRow} disableEdit={false} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              Create
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    handleAddNewCollection = () => {
      const { contentCollections, contentCollectionDialogID, newCollectionName } = this.state;

      const clonedContentCollections = cloneDeep(contentCollections);
      const foundContentCollection = clonedContentCollections.find(
        (contentCollection: IContentCollection) =>
          contentCollection.ID.toString() === contentCollectionDialogID.toString(),
      );
      if (foundContentCollection) {
        foundContentCollection.Name = newCollectionName;
        foundContentCollection.PublisherID = Number(this.props.session.publisher.ID);

        this.setState(
          {
            contentCollections: clonedContentCollections,
            updatingContentCollections: true,
          },
          () => {
            // create a new collection
            createContentCollection(foundContentCollection).then((response: any[]) => {
              const [contentCollection, err] = response;
              if (err) {
                this.setState({
                  contentCollections: clonedContentCollections,
                  updatingContentCollections: false,
                  snackbarMessage: 'Failed to create content collection',
                  snackbarError: true,
                  contentCollectionDialogActive: false,
                  contentCollectionDialogID: 0,
                  newContentCollectionActive: false,
                });
              } else {
                const updatedContentCollections = cloneDeep(this.state.contentCollections);
                updatedContentCollections.push(contentCollection);
                this.setState({
                  contentCollections: updatedContentCollections,
                  updatingContentCollections: false,
                  snackbarMessage: 'Successfully saved content collection',
                  snackbarError: false,
                  contentCollectionDialogActive: false,
                  contentCollectionDialogID: 0,
                  newContentCollectionActive: false,
                });
                this.genContentCollections();
              }
            });
          },
        );
      }
    };

    handleAddNewCollectionData = () => {
      const {
        contentCollectionData,
        contentCollectionDataDialogID,
        newCollectionDataName,
        newCollectionDataID,
        manageCollectionSelectedID,
      } = this.state;

      const clonedContentCollectionData = cloneDeep(contentCollectionData);
      const foundContentCollectionData = clonedContentCollectionData.find(
        (contentCollectionItem: IContentCollectionData) =>
          contentCollectionItem.ID === contentCollectionDataDialogID,
      );
      if (foundContentCollectionData) {
        foundContentCollectionData.Custom10TargetingAlias = newCollectionDataName;
        foundContentCollectionData.Custom10Targeting = Number(newCollectionDataID);
        foundContentCollectionData.ContentCollectionID = manageCollectionSelectedID;

        this.setState(
          {
            contentCollectionData: clonedContentCollectionData,
            updatingContentCollectionData: true,
          },
          () => {
            // create a new collection data
            createContentCollectionData(
              foundContentCollectionData,
              this.props.session.publisher.ID,
            ).then((response: any[]) => {
              const [contentCollectionData, err] = response;
              if (err) {
                this.setState({
                  contentCollectionData: clonedContentCollectionData,
                  updatingContentCollections: false,
                  snackbarMessage: 'Failed to create content collection',
                  snackbarError: true,
                  contentCollectionDialogActive: false,
                  contentCollectionDataDialogID: 0,
                  newContentCollectionActive: false,
                });
              } else {
                const updatedContentCollections = cloneDeep(this.state.contentCollections);
                updatedContentCollections.push(contentCollectionData);
                this.setState({
                  contentCollections: updatedContentCollections,
                  updatingContentCollections: false,
                  snackbarMessage: 'Successfully saved content collection',
                  snackbarError: false,
                  contentCollectionDialogActive: false,
                  contentCollectionDataDialogID: 0,
                  newContentCollectionActive: false,
                });
                this.genContentCollections();
              }
            });
          },
        );
      }
    };

    handleEditCollections = (collectionID: number, name: string) => {
      const { contentCollections } = this.state;
      const clonedCollections = cloneDeep(contentCollections);
      const foundCollection = clonedCollections.find(
        (collection: IContentCollection) => collection.ID.toString() === collectionID.toString(),
      );
      if (foundCollection) {
        foundCollection.Name = name;

        this.setState(
          {
            contentCollections: clonedCollections,
            updatingCollections: true,
          },
          () => {
            // update the existing collection
            updateContentCollection(foundCollection).then((response: any[]) => {
              const [newContentCollections, err] = response;
              if (err) {
                this.setState({
                  contentCollections: clonedCollections,
                  snackbarMessage: 'Failed to update content collection',
                  snackbarError: true,
                });
              } else {
                this.setState({
                  contentCollections: newContentCollections,
                  snackbarMessage: 'Successfully updated content collection',
                  snackbarError: false,
                });
                this.genContentCollections();
              }
            });
          },
        );
      }
    };

    handleEditCollectionData = (collectionDataID: number, name: string, dataID: number) => {
      const { contentCollectionData, contentCollections, manageCollectionSelectedID } = this.state;
      const clonedCollectionData = cloneDeep(contentCollectionData);
      const foundCollection = contentCollections.find(
        (collection: IContentCollection) =>
          collection.ID.toString() === manageCollectionSelectedID.toString(),
      );
      if (foundCollection) {
        const foundCollectionData = foundCollection.ContentCollectionData.find(
          (collectionData: IContentCollectionData) =>
            collectionData.ID.toString() === collectionDataID.toString(),
        );
        if (foundCollectionData) {
          foundCollectionData.Custom10TargetingAlias = name;
          foundCollectionData.Custom10Targeting = dataID;

          this.setState(
            {
              contentCollectionData: clonedCollectionData,
              updatingCollections: true,
            },
            () => {
              // update the existing collection
              updateContentCollectionData(
                foundCollectionData,
                this.props.session.publisher.ID,
              ).then((response: any[]) => {
                const [newContentCollectionData, err] = response;
                if (err) {
                  this.setState({
                    contentCollectionData: clonedCollectionData,
                    snackbarMessage: 'Failed to update content collection item',
                    snackbarError: true,
                  });
                } else {
                  this.setState({
                    contentCollection: newContentCollectionData,
                    snackbarMessage: 'Successfully updated content collection item',
                    snackbarError: false,
                  });
                  this.genContentCollections();
                }
              });
            },
          );
        }
      }
    };

    deleteCollection = (id: string) => {
      const { session } = this.props;
      this.setState({
        snackbarMessage: 'Successfully deleted collection',
        snackbarError: false,
        startingManageCollectionTab: 0,
      });
      return deleteContentCollection({
        query: {
          publisher_id: session.publisher.ID,
          content_collection_id: id,
        },
      }).then(() => {
        this.genContentCollections();
      });
    };

    deleteCollectionData = (id: string) => {
      const { session } = this.props;
      this.setState({
        snackbarMessage: 'Successfully deleted collection item',
        snackbarError: false,
        startingManageCollectionTab: 1,
      });
      return deleteContentCollectionData({
        query: {
          publisher_id: session.publisher.ID,
          content_collection_data_id: id,
        },
      }).then(() => {
        this.genContentCollections();
      });
    };

    render() {
      const { snackbarMessage, snackbarError, loading } = this.state;
      const { classes, user, session, location } = this.props;
      const { pathname } = location;

      if (!loading) {
        return (
          <Panels maxWidth vertical relative minWidthMain>
            <Panel largeHorizontalPadding verticalPadding>
              <ModelTopBar
                title={routeName(pathname)}
                session={session}
                user={user}
                publisher={session.publisher}
                classes={classes}
                delegateElevate={true}
                currentPath={pathname}
                disableTitlePaddingLeft
              />
            </Panel>
            <Panel>{this.renderAppBar()}</Panel>
            <Panel scroll largePadding>
              {this.renderTabs()}
              <SnackbarView
                open={!!snackbarMessage}
                error={!!snackbarError}
                onClose={this.handleSnackbarClose}
              >
                {snackbarMessage}
              </SnackbarView>
            </Panel>
          </Panels>
        );
      } else {
        return <LoadingView active={true} text='Loading the contextual segment settings' />;
      }
    }
  },
);
